/* eslint-disable no-param-reassign */
const SET_IS_OPEN = 'setIsOpen';

export const OPEN_NAV = 'openNav';
export const CLOSE_NAV = 'closeNav';

const mobileNav = {
  namespaced: true,

  state: {
    isOpen: false,
  },

  mutations: {
    [SET_IS_OPEN](state, isOpen) {
      state.isOpen = isOpen;
    },
  },

  actions: {
    [OPEN_NAV]({ commit }) {
      commit(SET_IS_OPEN, true);
    },

    [CLOSE_NAV]({ commit }) {
      commit(SET_IS_OPEN, false);
    },
  },
};

export default mobileNav;
